module.exports = __webpack_public_path__ + "s/img/Heart@2x.e5aa3a19.png";